@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.footer {
  background-color: var(--white);
  border-top: 1px solid var(--blue-01-at-30);
  padding: 8px;
  display: block;
  overflow: auto;
  font-size: .875rem;
  letter-spacing: 1px;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  @include breakpoints.desktop {
    height: 40px;
	border-top: 1px solid var(--white);
  }
}

.leftContainer {
	width: 100%;
	float: initial;
	text-align: center;
	@include breakpoints.desktop {
			width: 30%;
			float: left;
			text-align: initial;
	}
}

.rightContainer {
	float: initial;
	margin-top: 5px;
	color: var(--brand-indigo);
	margin-right: 35px;
	@include breakpoints.desktop {
			float: right;  
			font-family: typography.$font-mont;
			font-weight: 400;
			font-style: normal;
			font-size: 16px;
			line-height: 140%;
			letter-spacing: 0%;
			vertical-align: middle;
			margin-right: 0px;  
	}

	ul {
			margin: 0px;
			font-size: 1.000em;
	}
	li {
			float: initial;
			text-align: center;
			height: 30px;
			background: none;
			list-style: none;
			list-style-image: none;
			padding: 0px 15px;
			font-size: 14px;
			@include breakpoints.desktop {
					float: left;
					text-align: initial;
					height: initial;
					font-size: 16px;
			}

		a {
				text-decoration: none;
				cursor: pointer;
				color: inherit;
				font-family: typography.$font-mont;
		}
  }
}

.copyRight {
	font-family: typography.$font-mont;
	margin-left: 10px;
	padding: 5px 0px 0px 0px;
	color: var(--brand-indigo);
	font-weight: 700;
	font-style: normal;
	font-size: 14px;
	line-height: 22.4px;
	letter-spacing: 0px;
	text-align: center;
	vertical-align: middle;

	@include breakpoints.desktop {
		text-align: left;
		font-weight: 600;
		font-size: 16px;
		line-height: 140%;
	}
}